import {React, _n} from 'pexui';

export const PageHeader = ({visible, title, onBack, onClose}) => {
    if(visible){
        const backButton = onBack ?
            <div className="infw-icon-back-holder">
                <span className="infw-icon-left"
                    onClick={(evt)=>{
                        evt.preventDefault();
                        onBack()
                    }}
                    title={_n("footer.back")}/>
            </div>
            : <div className="infw-icon-back-holder"/>;
        const closeButton = onClose ?
            <div className="infw-icon-close-holder">
                <span className="infw-icon-close"
                    onClick={onClose}/>
            </div>
            : false;
        return <div className="infw-caption-bar"
                    style={{margin: '0px'}}>
                {backButton}
                <div className="infw-caption-bar-inner">
                    <span className="infw-caption-text">{title}</span>
                </div>
                {closeButton}
            </div>;
    }else{
        return '';
    };
}



// WEBPACK FOOTER //
// ./application/src/views/comps/header.jsx